// extracted by mini-css-extract-plugin
export default {"header":"ReserveProductModal_header__X2Dav","content":"ReserveProductModal_content__qOiD9","divider":"ReserveProductModal_divider__IutB9"};